import axios from "axios";

export const getApiData = async (apiName, objectId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/${apiName}`,
      {
        headers: {
          "X-User-ObjectId": objectId,
        },
      }
    );
    console.log(`Loaded ${apiName} data from API:`, res.data);
    return res.data;
  } catch (err) {
    console.error(`Failed to load ${apiName} data from API`, err);
    console.error("Error details:", err.response ? err.response.data : err.message);
    throw err;
  }
};


export const uploadPricingData = async (payload, objectId) => {
  try {
    const entries = Object.entries(payload).map(([sheetName, rows]) => {
      const url = `${process.env.REACT_APP_API_URL}/api/${sheetName}`;
      return axios.post(url, rows, {
        headers: {
          "X-User-ObjectId": objectId,
          "Content-Type": "application/json"
        }
      }).then(res => [sheetName, res.data]);
    });

    const resultsArray = await Promise.all(entries);
    return Object.fromEntries(resultsArray);
  } catch (err) {
    console.error("Failed to upload pricing data", err.response ? err.response.data : err.message);
    throw err;
  }
};


export const postZones = async (zones, objectId) => {
  try {

    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/zones`, zones, {
      headers: {
        "X-User-ObjectId": objectId,
        "Content-Type": "application/json"
        
      }
    });

    console.log("Response:", response.data);
  } catch (error) {
    console.error("Error posting zones:", error);
  }
};




